var render = function render(){var _vm=this,_c=_vm._self._c;return _c('th',{attrs:{"data-align":"center","data-column-id":"e","data-formatter":"e","data-sortable":"false","data-width":"36px","title":"Editar","data-header-no-icon":"true"}},[_vm._v("...")])
}
var staticRenderFns = []

export { render, staticRenderFns }